import { render, staticRenderFns } from "./paymentContent.vue?vue&type=template&id=0b79c9a2&scoped=true"
import script from "./paymentContent.vue?vue&type=script&lang=js"
export * from "./paymentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79c9a2",
  null
  
)

export default component.exports